import { Box, useTheme } from "@mui/material";

export const DragModeSnackbar = ({
	visible,
	freeMode = false,
}: {
	visible: boolean;
	freeMode?: boolean;
}) => {
	const theme = useTheme();

	if (!visible) return null;

	return (
		<Box
			sx={{
				position: "fixed",
				bottom: 24,
				left: "50%",
				transform: "translateX(-50%)",
				backgroundColor: freeMode
					? theme.palette.primary.dark
					: theme.palette.grey[800],
				color: theme.palette.common.white,
				padding: "10px 20px",
				borderRadius: "8px",
				fontSize: "0.875rem",
				boxShadow: "0 4px 12px #0000004C",
				zIndex: 10000,
				pointerEvents: "none",
			}}
		>
			{freeMode ? (
				<>
					Free placement (1h steps) — release <strong>Shift</strong> to snap to
					events
				</>
			) : (
				<>
					Drag and Drop — hold <strong>Shift</strong> for free placement · hold
					over a side strip to change month · press <strong>'ESC'</strong> to
					cancel
				</>
			)}
		</Box>
	);
};
